import { Button, FloatingMenu, Select, Spacer } from '@components';
import { BUTTON_TYPES, ILaneRateCard, RATE_CARD_TRUCK_SIZE } from '@types';
import styles from './RateCard.module.scss';
import AddIcon from '@mui/icons-material/Add';
import { useState } from 'react';
import EditOutlined from '@mui/icons-material/EditOutlined';
import { getRateCardTruckSizeLabel } from '@utils';
import DeleteOutline from '@mui/icons-material/DeleteOutline';

type TTruckSizeFloatingMenuProps = {
	trucks: RATE_CARD_TRUCK_SIZE[];
	isEdit?: boolean;
	rateCard?: ILaneRateCard;
	currentTruck: RATE_CARD_TRUCK_SIZE | null;
	onEdit?: (previousTruck: RATE_CARD_TRUCK_SIZE, newTruck: RATE_CARD_TRUCK_SIZE) => void;
	onDelete?: (truckToDelete: RATE_CARD_TRUCK_SIZE | null) => void;
	onAdd?: (newTruck: RATE_CARD_TRUCK_SIZE) => void;
	isLastColumn?: boolean;
}


export const TruckSizeFloatingMenu = (props: TTruckSizeFloatingMenuProps) => {
	const {
		rateCard,
		trucks,
		isEdit,
		currentTruck,
		onEdit,
		onDelete,
		onAdd,
		isLastColumn = false
	} = props;

	const [isOpen, setIsOpen] = useState(false);

	return <FloatingMenu open={isOpen} onMenuToggle={setIsOpen}>
		{
			isEdit ? <EditOutlined className={styles.ctaButton} /> :
				<AddIcon className={styles.ctaButton} />
		}
		<FloatingMenu.Menu menuPos={isLastColumn ? 'right' : 'center'} borderRadius={0} closeOnClick={false}>
			<div className={styles.floatingMenuContainer}>
				<div className={styles.floatingMenuTrucksContainer}>
					{
						trucks.map((truck, index) => {
							return (
								<div
									onClick={() => {
										if (rateCard?.rangePrices?.[truck]) return;
										isEdit && currentTruck ? onEdit?.(currentTruck, truck) : onAdd?.(truck);
										setIsOpen(false);
									}}
									key={index}
								>
									<Select.Option
										key={truck}
										value={truck}
										isDisabled={!!rateCard?.rangePrices?.[truck]}
									>
										{getRateCardTruckSizeLabel(truck)}
									</Select.Option>
								</div>
							)
						})
					}
				</div>

				{
					isEdit && <>
						<Spacer size={0} divider/>
						<div className={styles.floatingMenuButton}>
							<Button
								Icon={DeleteOutline}
								type={BUTTON_TYPES.TERTIARY}
								onClick={() => {
									currentTruck && onDelete?.(currentTruck);
									setIsOpen(false);
								}}
								text={'Delete column'}
							/>
						</div>
					</>
				}
			</div>
		</FloatingMenu.Menu>
	</FloatingMenu>
}